import React from 'react'
import Icon from './icon'
import Header from './header'
import { Field } from './field'
import { Avatar, Thumb } from './picture'
import { MenuIcon, MenuItem } from './menu'
import './table2.css'

/*****************************************************************************/
/* Table Row
/*****************************************************************************/
const Row = class extends React.Component {

  static defaultProps = {
    edit: false
  }

  state = {
    edit: this.props.edit,
    editions: {}
  }

  toggleCheck = () => {
    const { onCheck, cells } = this.props
    if (onCheck) onCheck(cells.id)
  }

  toggleEdit = () => {
    const edit = !this.state.edit
    const editions = {}
    this.setState({ edit, editions })
  }

  changeField = (field, value) => {
    const { columns, cells } = this.props
    const column = columns.find(column => column.type === field)
    if (column.field) {
      column.onChange(cells.id, field, value)
    }
    let editions = { ...this.state.editions }
    editions[field] = value
    this.setState({ editions })
  }

  handleEdit = () => {
    const { cells, onEdit } = this.props
    if (onEdit) onEdit(cells.id, this.state.editions)
    this.toggleEdit()
  }

  handleSelect = () => {
    const { cells, onSelect } = this.props
    if (onSelect) onSelect(cells.id)
  }

  handleDelete = () => {
    const { onDelete, cells } = this.props
    if (onDelete) onDelete(cells.id)
  }

  cell = (type, value) => {
    const { columns } = this.props
    const checkIcon = value === false ? 'check_box_outline_blank' : 'check_box'
    const column = columns.find(column => column.type === type)
    if (column.field || (this.state.edit && column.editable)) {
      const edition = this.state.editions[type] ? this.state.editions[type] : ''
      return <Field id={type} placeholder={value} value={edition} onChange={this.changeField} />
    } else {
      switch (type) {
        case 'check': return <Icon icon={checkIcon} clickable action={this.toggleCheck} className="square" />
        case 'index': return this.props.index
        case 'icon': return <Icon icon={value} />
        case 'thumb': return <Thumb src={value} />
        case 'avatar': return <Avatar avatar={value} {...value} />
        case 'name': return value
        case 'value': return value
        case 'menu': return <MenuIcon>{value.items.map((item, i) => (<MenuItem id={i} {...item} />))}</MenuIcon>
        default: return <span>{value}</span>
      }
    }
  }

  renderPocket = (actions = []) => {
    const { onEdit, onDelete, pocket } = this.props
    let translation = 6 + (actions.length * 3)
    if (onEdit) translation = translation + 6;
    const style = pocket===true ? 'pocket' : 'actions'
    return this.state.edit ? (
      <td className={style}>
        <div className="pocket-in">
          {pocket ? <span className="dots">...</span> : ''}
          <Icon icon="close" className="small square" clickable action={this.toggleEdit} />
          <Icon icon="done" className="small square" clickable action={this.handleEdit} />
        </div>
      </td>
    ) : (
        <td className={style}>
          <div className="pocket-in">
            {pocket ? <span className="dots">...</span> : ''}
            {actions.map(({ icon, action }) => (<Icon icon={icon} className="small" clickable action={action} />))}
            {onEdit ? <Icon icon="edit" className="small" clickable action={this.toggleEdit} /> : ''}
            {onDelete ? <Icon icon="delete" className="small" clickable action={this.handleDelete} /> : ''}
          </div>
        </td>
      )
  }

  render() {
    const { columns, cells, className, onEdit, onDelete } = this.props
    const editable = onEdit ? 'editable' : ''
    const color = cells.color ? cells.color : ''
    return (
      <tr className={`${className} ${color} ${editable}`} onClick={this.handleSelect}>
        {columns.map(column => {
          const col_title = column.title ? 'col_title' : ''
          return (
            <td className={`cell ${col_title} col_${column.type}`}>
              {this.cell(column.type, cells[column.type])}
            </td>
          )
        })}
        {cells.actions && cells.actions.length > 0 || onEdit || onDelete ? this.renderPocket(cells.actions) : ''}
      </tr>
    )
  }
}

/*****************************************************************************/
/* Table
/*****************************************************************************/
const Table = ({ index, icon, title, rows = [], columns = [], children, onSelect, onCheck, onDelete, onEdit, footer, pocket }) => {

  const renderFooter = () => {
    return footer ? (
      <tfoot>
        <tr>
          <td colSpan={columns.length}>
            {footer}
          </td>
        </tr>
      </tfoot>
    ) : ''
  }

  return (
    <div className="table-box">
      {title || children ? (<Header icon={icon ? { icon } : null} title={title} className="table-header">{children}</Header>) : ''}
      <table className="table2" >
        <colgroup>
          {columns.map(column => <col className={`col_${column.type}`} />)}
        </colgroup>
        <thead>
          {columns.map(column => <th className={`col_${column.type}`}>{column.label}</th>)}
        </thead>
        <tbody>
          {rows.map((row, index) => <Row index={index} columns={columns} cells={row} className={row.className} onSelect={onSelect} onCheck={onCheck} onDelete={onDelete} onEdit={onEdit} pocket={pocket} />)}
        </tbody>
        {renderFooter()}
      </table>
    </div>
  )
}

export default Table;



// WEBPACK FOOTER //
// ./src/lib/components/table2.js